/**
 * Selects a value based on the current tenant at build time.
 *
 * REACT_APP_TENANT is replaced with a string literal by webpack's DefinePlugin.
 * Terser evaluates the constant conditions and drops the dead branch,
 * so the unused tenant's assets and theme are excluded from the bundle.
 *
 * Always use this function (or explicit if/ternary) — never a dict/object
 * keyed on the tenant. See skills/tenant-theme/SKILL.md for the full rationale.
 */
export function byTenant<T>(jameo: T, attraction: T): T {
  if (process.env.REACT_APP_TENANT === "jameo") return jameo;
  if (process.env.REACT_APP_TENANT === "attraction") return attraction;
  return jameo; // local dev fallback — set REACT_APP_TENANT in .env
}
